import { NaveganteTemplateConfig } from '../../..';
import React, { createContext, useContext } from 'react';
import { AppProps } from '../App';

interface AppContextProps {
  config: NaveganteTemplateConfig;
}

const AppContext = createContext<AppContextProps | undefined>(undefined);

interface WithAppPropsBase {}

type WithAppProps = React.PropsWithChildren<WithAppPropsBase> & AppProps;

export function WithApp(props: WithAppProps) {
  return (
    <AppContext.Provider value={{ config: props.config }}>{props.children}</AppContext.Provider>
  );
}

export function useApp() {
  const context = useContext(AppContext);
  if (context === undefined) {
    throw new Error('useApp must be used within a AppProvider');
  }
  return context;
}
